import React, { useEffect, useState, useRef } from "react";
import { NavLink } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import logo from "../images/QuontX_logo.png";
import { deleteCache } from "../api/quontxApi";

const Navbar = () => {
  const { user, logout } = useAuth();
  const [isSuperuser, setIsSuperuser] = useState();
  const [loading, setLoading] = useState(false);
  const [loadingDeleteCache, setLoadingDeleteCache] = useState(false);
  const [isAnalysisDropdownOpen, setIsAnalysisDropdownOpen] = useState(false);
  const [isSourceTreeDropdownOpen, setIsSourceTreeDropdownOpen] = useState(false);
  const analysisCloseTimeoutRef = useRef(null);
  const sourceTreeCloseTimeoutRef = useRef(null);

  useEffect(() => {
    const superuserStatus = localStorage.getItem("is_superuser");
    if (superuserStatus.toLowerCase() === "true") {
      setIsSuperuser(true);
    }
    if (superuserStatus.toLowerCase() === "false") {
      setIsSuperuser(false);
    }
  }, []);

  const onLogout = () => {
    setLoading(true);
    logout();
  };

  const onDeleteCache = async () => {
    setLoadingDeleteCache(true);
    await deleteCache();
    setLoadingDeleteCache(false);
  };

  const handleAnalysisMouseEnter = () => {
    if (analysisCloseTimeoutRef.current) {
      clearTimeout(analysisCloseTimeoutRef.current);
    }
    setIsAnalysisDropdownOpen(true);
  };

  const handleAnalysisMouseLeave = () => {
    analysisCloseTimeoutRef.current = setTimeout(() => {
      setIsAnalysisDropdownOpen(false);
    }, 300);
  };

  const handleSourceTreeMouseEnter = () => {
    if (sourceTreeCloseTimeoutRef.current) {
      clearTimeout(sourceTreeCloseTimeoutRef.current);
    }
    setIsSourceTreeDropdownOpen(true);
  };

  const handleSourceTreeMouseLeave = () => {
    sourceTreeCloseTimeoutRef.current = setTimeout(() => {
      setIsSourceTreeDropdownOpen(false);
    }, 300);
  };

  return (
    <nav className="bg-qtx-darker shadow-lg sticky top-0 left-0 z-[100]">
      <div className="max-w-[88rem] mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          <div className="flex items-center">
            <div className="flex-shrink-0 text-white font-bold text-2xl">
              <img src={logo} alt="QuontX Logo" className="h-8 w-auto" />
            </div>
            <div className="hidden md:block">
              <div className="ml-10 flex items-baseline space-x-4">
                {isSuperuser && (
                  <div className="space-x-4">
                    <NavLink
                      to="/extractions"
                      className={({ isActive }) =>
                        `px-3 py-2 rounded-md text-sm font-medium ${
                          isActive
                            ? "bg-qtx-dark text-white bg-qtx-gray"
                            : "text-qtx-light-gray hover:bg-qtx-gray hover:text-white"
                        }`
                      }
                    >
                      Extractions
                    </NavLink>
                    <NavLink
                      to="/jobs"
                      className={({ isActive }) =>
                        `px-3 py-2 rounded-md text-sm font-medium ${
                          isActive
                            ? "bg-qtx-dark text-white bg-qtx-gray"
                            : "text-qtx-light-gray hover:bg-qtx-gray hover:text-white"
                        }`
                      }
                    >
                      Jobs
                    </NavLink>
                    <NavLink
                      to="/sources"
                      className={({ isActive }) =>
                        `px-3 py-2 rounded-md text-sm font-medium ${
                          isActive
                            ? "bg-qtx-dark text-white bg-qtx-gray"
                            : "text-qtx-light-gray hover:bg-qtx-gray hover:text-white"
                        }`
                      }
                    >
                      Sources
                    </NavLink>
                    <NavLink
                      to="/users"
                      className={({ isActive }) =>
                        `px-3 py-2 rounded-md text-sm font-medium ${
                          isActive
                            ? "bg-qtx-dark text-white bg-qtx-gray"
                            : "text-qtx-light-gray hover:bg-qtx-gray hover:text-white"
                        }`
                      }
                    >
                      Users
                    </NavLink>
                  </div>
                )}

                {/* Analysis Dropdown */}
                <div
                  className="relative inline-block"
                  onMouseEnter={handleAnalysisMouseEnter}
                  onMouseLeave={handleAnalysisMouseLeave}
                >
                  <button className="px-3 py-2 rounded-md text-sm font-medium text-qtx-light-gray hover:bg-qtx-gray hover:text-white">
                    Analysis ▼
                  </button>

                  {isAnalysisDropdownOpen && (
                    <div className="absolute left-0 mt-0 w-48 bg-qtx-dark rounded-md shadow-lg z-50">
                      <div className="py-1">
                        <NavLink
                          to="/node-analysis"
                          className={({ isActive }) =>
                            `block px-4 py-2 text-sm ${
                              isActive
                                ? "bg-qtx-gray text-white"
                                : "text-qtx-light-gray hover:bg-qtx-gray hover:text-white"
                            }`
                          }
                          onClick={() => setIsAnalysisDropdownOpen(false)}
                        >
                          Org Profile Analysis
                        </NavLink>
                        <NavLink
                          to="/risk-analysis"
                          className={({ isActive }) =>
                            `block px-4 py-2 text-sm ${
                              isActive
                                ? "bg-qtx-gray text-white"
                                : "text-qtx-light-gray hover:bg-qtx-gray hover:text-white"
                            }`
                          }
                          onClick={() => setIsAnalysisDropdownOpen(false)}
                        >
                          Org Risk Analysis
                        </NavLink>
                        <NavLink
                          to="/edge-analysis"
                          className={({ isActive }) =>
                            `block px-4 py-2 text-sm ${
                              isActive
                                ? "bg-qtx-gray text-white"
                                : "text-qtx-light-gray hover:bg-qtx-gray hover:text-white"
                            }`
                          }
                          onClick={() => setIsAnalysisDropdownOpen(false)}
                        >
                          Edge Analysis
                        </NavLink>
                        <NavLink
                          to="/graph-analysis"
                          className={({ isActive }) =>
                            `block px-4 py-2 text-sm ${
                              isActive
                                ? "bg-qtx-gray text-white"
                                : "text-qtx-light-gray hover:bg-qtx-gray hover:text-white"
                            }`
                          }
                          onClick={() => setIsAnalysisDropdownOpen(false)}
                        >
                          Graph Analysis
                        </NavLink>
                      </div>
                    </div>
                  )}
                </div>

                {/* Source Tree Dropdown */}
                {isSuperuser && (
                  <div
                    className="relative inline-block"
                    onMouseEnter={handleSourceTreeMouseEnter}
                    onMouseLeave={handleSourceTreeMouseLeave}
                  >
                    <button className="px-3 py-2 rounded-md text-sm font-medium text-qtx-light-gray hover:bg-qtx-gray hover:text-white">
                      Node Trees ▼
                    </button>

                    {isSourceTreeDropdownOpen && (
                      <div className="absolute left-0 mt-0 w-56 bg-qtx-dark rounded-md shadow-lg z-50">
                        <div className="py-1">
                          <NavLink
                            to="/source-tree"
                            className={({ isActive }) =>
                              `block px-4 py-2 text-sm ${
                                isActive
                                  ? "bg-qtx-gray text-white"
                                  : "text-qtx-light-gray hover:bg-qtx-gray hover:text-white"
                              }`
                            }
                            onClick={() => setIsSourceTreeDropdownOpen(false)}
                          >
                            Node Tree
                          </NavLink>
                          <NavLink
                            to="/source-tree-analytical"
                            className={({ isActive }) =>
                              `block px-4 py-2 text-sm ${
                                isActive
                                  ? "bg-qtx-gray text-white"
                                  : "text-qtx-light-gray hover:bg-qtx-gray hover:text-white"
                              }`
                            }
                            onClick={() => setIsSourceTreeDropdownOpen(false)}
                          >
                            Analytical Node Tree
                          </NavLink>
                        </div>
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
          {user && (
            <div className="flex gap-2">
              {isSuperuser && (
                <div className="flex items-center">
                  <button
                    onClick={onDeleteCache}
                    disabled={loadingDeleteCache}
                    className="bg-red-500 disabled:opacity-50 disabled:cursor-not-allowed hover:bg-red-600 text-white px-3 py-2 rounded-md text-sm font-medium"
                  >
                    Delete cache
                  </button>
                </div>
              )}
              <div className="flex items-center">
                <span className="text-qtx-gray mr-4 text-sm">{user.email}</span>
                <button
                  onClick={onLogout}
                  disabled={loading}
                  className="bg-qtx-blue disabled:opacity-50 disabled:cursor-not-allowed hover:bg-blue-600 text-white px-3 py-2 rounded-md text-sm font-medium"
                >
                  Logout
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </nav>
  );
};

export default Navbar;